/**
 * Non-blocking offline / reconnect status banner (Wave E.5).
 * Always exposes `aria-live="polite"` so assistive tech hears status changes.
 * Deep offline recovery stays on the OfflineRecovery route (MS-REC-071).
 */

export interface OfflineBannerProps {
  readonly message: string;
  readonly className?: string;
  readonly testId?: string;
}

export function OfflineBanner({
  message,
  className,
  testId = 'customer-offline-banner',
}: OfflineBannerProps): JSX.Element {
  return (
    <div
      className={[
        'flex items-center gap-2 rounded-md border border-[var(--color-warning,var(--color-border))]',
        'bg-[var(--color-surface-elevated,var(--color-surface))] px-3 py-2 text-sm',
        'text-[var(--color-on-surface)] shadow-[var(--shadow-popover,0_4px_12px_rgba(0,0,0,0.08))]',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      role="status"
      aria-live="polite"
      data-testid={testId}
      data-tone="warn"
    >
      <p className="m-0 flex-1">{message}</p>
    </div>
  );
}
